import request from "@/utils/request";

//获取点位
export function getCarParkByPosition(data) {
  return request({
    url: "/getCarParkByPosition",
    method: "post",
    data: data
  });
}

export function getSign() {
  return request({
    url: "/getSign",
    method: "get"
  });
}

export function queryPosition(data) {
  return request({
    url: `/query?query=${data}`,
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js